export default {
    computed: {
        cashingsCustomerSearchConfig() {
            return {
                'default_uri': '/customers', 
                'default_params': {
                    'validated': 1,
                    'paginate': 0,
                    'eager_loading': 0,
                    'with': 'main_address'
                }, 
                'default_data_index': 'customers', 
                'specific_cases': {
                    'max: 3': {
                        'uri': '/customers', 
                        'params': {
                            'validated': 1,
                            'paginate': 0,
                            'eager_loading': 0,
                            'with': 'main_address',
                            'searchFields': 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:='
                        }, 
                        'data_index': 'customers'
                    }
                }
            }
        },

        hotlineCustomerSearchConfig() {
            return {
                'default_uri': 'customers', 
                'default_params': {
                    'active': 1,
                    'simple_hotline': 1, 
                    'paginate': 0
                }, 
                'default_data_index': 'customers', 
                'specific_cases': {
                    'max: 3': {
                        'uri': 'customers', 
                        'params': {
                            'active': 1,
                            'simple_hotline': 1, 
                            'paginate': 0,
                            'searchFields': 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:='
                        }, 
                        'data_index': 'customers'
                    }
                }
            }
        },

        newLeadCustomerSearchConfig() {
            return {
                'default_uri': 'customers', 
                'default_params': {
                    'paginate': 0,
                    'eager_loading': 0,
                    'with': 'main_address;buyers'
                }, 
                'default_data_index': 'customers', 
                'specific_cases': {
                    'max: 3': {
                        'uri': 'customers', 
                        'params': {
                            'paginate': 0,
                            'eager_loading': 0,
                            'with': 'main_address;buyers',
                            'searchFields': 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:='
                        }, 
                        'data_index': 'customers'
                    }
                }
            }
        },

        existingLeadCustomerSearchConfig() {
            return {
                'default_uri': 'customers', 
                'default_params': {
                    'paginate': 0,
                    'eager_loading': 0,
                    'with': 'main_address'
                }, 
                'default_data_index': 'customers', 
                'specific_cases': {
                    'max: 3': {
                        'uri': 'customers', 
                        'params': {
                            'paginate': 0,
                            'eager_loading': 0,
                            'with': 'main_address',
                            'searchFields': 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:='
                        }, 
                        'data_index': 'customers'
                    }
                }
            }
        },

        intermediaryBusinessSearchConfig() {
            return {
                'default_uri': 'intermediary_business', 
                'default_params': {
                    'paginate': 0,
                    'with': 'address'
                }, 
                'default_data_index': 'intermediary_businesses'
            }
        },

        buyerCustomerSearchConfig() {
            return {
                'default_uri': '/customers', 
                'default_params': {
                    'paginate': 0,
                    'eager_loading': 0
                }, 
                'default_data_index': 'customers', 
                'specific_cases': {
                    'max: 3': {
                        'uri': '/customers', 
                        'params': {
                            'paginate': 0,
                            'eager_loading': 0,
                            'searchFields': 'name:=;trade_name:=;representatives.corporation_name:=;representatives.first_name:=;representatives.last_name:=;brands.name:='
                        }, 
                        'data_index': 'customers'
                    }
                }
            }
        },
    },

    methods: {
        getCustomerNameWithErpId(customer) {
            let erpString = customer.erp_id ? customer.erp_id : 'Prospect'

            return customer.name + ` (${erpString})`;
        },
      
        getCustomerNameWithRepresentativeAndErpId(customer) {
            let formattedCustomer = customer.name
            const erpString = customer.erp_id ? `#${customer.erp_id}` : 'Prospect'
        
            if (customer.main_representative) {
                const decodedRepresentativeQuality = `(${customer.main_representative.decoded_representative_quality})` || ''
        
                formattedCustomer += ` / ${customer.main_representative.first_name || ''} ${customer.main_representative.last_name || ''} ${decodedRepresentativeQuality}`
            }
        
            formattedCustomer += ` - ${erpString}`
        
            return formattedCustomer
        },

        getIntermediaryBusinessSearchLabel(intermediaryBusiness) {
            return intermediaryBusiness.name + ` (${intermediaryBusiness.erp_id})`;
        },
    }
}


// WEBPACK FOOTER //
// ./client/mixins/search.js